import React from 'react';

const DivRow = ({ width = 'auto', children, className = '' }) => {


    return (
        <div  className="col-ca">
            {children}
        </div>
    );
}

export { DivRow };
